define("shared/components/shared/pre-boarding/index", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "later/services/onboarding", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _onboarding, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/services/onboarding",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::PreBoarding::Survey @onCloseSelfDescribes={{this.onCloseSelfDescribes}} />
  
  {{#if this.shouldShowSocialConnectOnboarding}}
    <Shared::PreBoarding::SocialConnect @closeModal={{this.closeSocialConnectOnboarding.perform}} />
  {{/if}}
  
  {{#if this.shouldShowAutoTrialStartModal}}
    <Shared::PreBoarding::AutoTrialStart @closeModal={{this.closeAutoTrialStartModal}} />
  {{/if}}
  
  {{#if this.shouldShowAutoTrialEndModal}}
    <Shared::PreBoarding::AutoTrialEnd
      @toggleAutoTrialEndModal={{this.toggleAutoTrialEndModal}}
      @trialedPlan={{this.trialedPlan}}
    />
  {{/if}}
  
  {{#if this.shouldShowSourcelessTrialExpiryModal}}
    <Shared::PreBoarding::SourcelessTrialEnd
      @toggleSourceLessTrialEndModal={{this.toggleSourceLessTrialEndModal}}
      @trialedPlan={{this.sourcelessTrialedPlan}}
    />
  {{/if}}
  */
  {
    "id": "vzx/bZvC",
    "block": "[[[8,[39,0],null,[[\"@onCloseSelfDescribes\"],[[30,0,[\"onCloseSelfDescribes\"]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"shouldShowSocialConnectOnboarding\"]],[[[1,\"  \"],[8,[39,2],null,[[\"@closeModal\"],[[30,0,[\"closeSocialConnectOnboarding\",\"perform\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"shouldShowAutoTrialStartModal\"]],[[[1,\"  \"],[8,[39,3],null,[[\"@closeModal\"],[[30,0,[\"closeAutoTrialStartModal\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"shouldShowAutoTrialEndModal\"]],[[[1,\"  \"],[8,[39,4],null,[[\"@toggleAutoTrialEndModal\",\"@trialedPlan\"],[[30,0,[\"toggleAutoTrialEndModal\"]],[30,0,[\"trialedPlan\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"shouldShowSourcelessTrialExpiryModal\"]],[[[1,\"  \"],[8,[39,5],null,[[\"@toggleSourceLessTrialEndModal\",\"@trialedPlan\"],[[30,0,[\"toggleSourceLessTrialEndModal\"]],[30,0,[\"sourcelessTrialedPlan\"]]]],null],[1,\"\\n\"]],[]],null]],[],false,[\"shared/pre-boarding/survey\",\"if\",\"shared/pre-boarding/social-connect\",\"shared/pre-boarding/auto-trial-start\",\"shared/pre-boarding/auto-trial-end\",\"shared/pre-boarding/sourceless-trial-end\"]]",
    "moduleName": "shared/components/shared/pre-boarding/index.hbs",
    "isStrictMode": false
  });
  let PreBoardingComponent = _exports.default = (_class = class PreBoardingComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "creatorCohort", _descriptor2, this);
      _initializerDefineProperty(this, "onboarding", _descriptor3, this);
      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor4, this);
      _initializerDefineProperty(this, "segment", _descriptor5, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor6, this);
      _initializerDefineProperty(this, "trialedPlan", _descriptor7, this);
      _initializerDefineProperty(this, "shouldShowAutoTrialStartModal", _descriptor8, this);
      _initializerDefineProperty(this, "shouldShowAutoTrialEndModal", _descriptor9, this);
      _initializerDefineProperty(this, "shouldSourcelessTrialEndModalBeVisible", _descriptor10, this);
      _defineProperty(this, "closeSocialConnectOnboarding", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.onboarding.setPowerUserOnboardingState.perform(_onboarding.POWER_USER_ONBOARDING_STATES.SKIPPED_SOCIAL_CONNECT);
          if (!this.hasConnectedSocialProfile) {
            this.segment.track('skipped-social-connect', {
              area: 'social-connect-modal-onboarding'
            });
          }
        }
      }), null, "closeSocialConnectOnboarding", null));
      _defineProperty(this, "loadRecentlyExpiredPlan", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.trialedPlan = yield this.subscriptions.getSubscriptionPlan('recently_expired');
        }
      }), null, "loadRecentlyExpiredPlan", null));
      _defineProperty(this, "onCloseTrialPlansModal", async () => {
        await this.onboarding.setPowerUserOnboardingState.perform(_onboarding.POWER_USER_ONBOARDING_STATES.SEEN_ONBOARDING_TRIAL_MODAL);
        await this.onboarding.setPowerUserOnboardingState.perform(_onboarding.POWER_USER_ONBOARDING_STATES.CONNECTING_SOCIAL);
      });
      this.loadRecentlyExpiredPlan.perform();
      this.shouldShowAutoTrialEndModal = this.autoTrialSubscriptionExpired && !this.subscriptions.cardlessTrialCampaignCompleted && !this.isCreatorCohort;
      if (this.onboarding.shouldSkipSelfDescribes && !this.onboarding.hasSeenOnboardingTrialModal) {
        this.handleTrialModals();
      }
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }

    /**
     * Creator cohort users should not see plan or pricing trial modals when accessing Calendar or mobile.
     * Uses the same logic as the index route (creator/Mavely signup or influencer record).
     */
    get isCreatorCohort() {
      return this.creatorCohort.isCreatorCohort(this.auth.lastGroup);
    }
    get autoTrialSubscriptionExpired() {
      return !this.subscriptions.hasCurrentSubscription && this.subscriptions.isLatestSubscriptionAutoTrial && !this.subscriptions.latestSubscription?.isActive;
    }
    get sourcelessTrialSubscriptionExpired() {
      return !this.subscriptions.hasCurrentSubscription && this.subscriptions.isLatestSubscriptionSourcelessTrial && !this.subscriptions.latestSubscription?.isActive;
    }
    get shouldShowSocialConnectOnboarding() {
      return this.onboarding.shouldShowSocialConnectOnboarding;
    }
    get shouldShowSourcelessTrialExpiryModal() {
      return !this.isCreatorCohort && this.sourcelessTrialSubscriptionExpired && !this.subscriptions.cardlessTrialCampaignCompleted && this.shouldSourcelessTrialEndModalBeVisible;
    }
    get hasConnectedSocialProfile() {
      return this.auth.currentGroup.socialProfiles.get('length') > 0;
    }
    closeAutoTrialStartModal() {
      this.shouldShowAutoTrialStartModal = false;
      this.showPowerUserOnboardingSocialConnectModal();
    }
    toggleAutoTrialEndModal() {
      this.shouldShowAutoTrialEndModal = !this.shouldShowAutoTrialEndModal;
    }
    toggleSourceLessTrialEndModal() {
      this.shouldSourcelessTrialEndModalBeVisible = !this.shouldSourcelessTrialEndModalBeVisible;
    }
    async showPowerUserOnboardingSocialConnectModal() {
      await this.onboarding.setPowerUserOnboardingState.perform(_onboarding.POWER_USER_ONBOARDING_STATES.CONNECTING_SOCIAL);
    }
    onCloseSelfDescribes() {
      // Only show the trial and social connect modals if the user hasn't seen them yet
      if (!this.onboarding.hasSeenOnboardingTrialModal) {
        this.handleTrialModals();
      } else if (!this.onboarding.isPowerUserConnectingSocial) {
        this.showPowerUserOnboardingSocialConnectModal();
      }
    }
    handleTrialModals() {
      if (this.subscriptions.isOnAutoTrial) {
        this.shouldShowAutoTrialStartModal = true;
      } else if (this.auth.currentAccount.canTrialPlan && !this.isCreatorCohort) {
        this.seamlessCheckoutManager.openTrialPlansModal({
          onCloseOrSuccess: this.onCloseTrialPlansModal,
          location: 'onboarding_plan_snapshot',
          trialStartLocation: 'create account onboarding'
        });
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "creatorCohort", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "onboarding", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "trialedPlan", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return {};
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "shouldShowAutoTrialStartModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "shouldShowAutoTrialEndModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "shouldSourcelessTrialEndModalBeVisible", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "closeAutoTrialStartModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeAutoTrialStartModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleAutoTrialEndModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleAutoTrialEndModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSourceLessTrialEndModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSourceLessTrialEndModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPowerUserOnboardingSocialConnectModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "showPowerUserOnboardingSocialConnectModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCloseSelfDescribes", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onCloseSelfDescribes"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PreBoardingComponent);
});